import React from "react";
import { MdChevronRight } from "react-icons/md";

export interface INextArrowProps {
  onClick?: React.MouseEventHandler<SVGElement>;
  style?: any;
  className?: string;
}

export const NextArrow: React.FC<INextArrowProps> = ({
  onClick,
  style,
  className,
}) => {
  return (
    <span
      className={`absolute top-1/2 z-10 cursor-pointer text-white text-6xl drop-shadow -mt-6 inline-block right-0`}
    >
      <MdChevronRight onClick={onClick} />
    </span>
  );
};
